import inlineSvg from '@/script/inlineSvg.mjs'

const L = 12

const Arrow = (w=60, h=30, bgColor = '#fff', borderColor="#ffff99") => {
    const bw = 2;
    const paddings = [bw, bw + L, bw, bw + L]


    return inlineSvg(
      `<svg 
        xmlns="http://www.w3.org/2000/svg"
        fill="${bgColor}"
        stroke="${borderColor}"
        stroke-width="2"
      >
        <path
            d="
                M ${bw / 2} ${bw / 2}
                H ${w - L - bw / 2}
                L ${w - bw / 2} ${h / 2}
                L ${w - L - bw / 2} ${h - bw / 2}
                H ${bw / 2}
                L ${bw / 2 + L} ${h / 2}
                Z
            "
        />
      </svg>`
    )
}

export default Arrow;